window.addEventListener("load", function() {
  const btn = document.getElementById("btn-to-message");
  const title = document.getElementById("section-mv__title");
  const box01 = document.getElementById("box-mv-img--01");
  const box02 = document.getElementById("box-mv-img--02");
  const box03 = document.getElementById("box-mv-img--03");
  const box04 = document.getElementById("box-mv-img--04");
  const box05 = document.getElementById("box-mv-img--05");
  const box06 = document.getElementById("box-mv-img--06");
  const box07 = document.getElementById("box-mv-img--07");

  const boxes = [box01, box02, box03, box04, box05, box06, box07];

  boxes.forEach((box, index) => {
    if (box !== null) {
      setTimeout(() => {
        box.classList.add("active");
      }, index * 200);
    }
  });

  if (title !== null) {
    setTimeout(() => {
      title.style.opacity = "1";
    }, 2000);
  }

  if (btn !== null) {
    setTimeout(() => {
      btn.style.opacity = "1";
    }, 2700);
  }
});
